// extracted by mini-css-extract-plugin
module.exports = {"RuleInformationModal":"RuleInformationModal_RuleInformationModal__3UIFx"};